<script lang="ts">
  import { type Debtor } from "$apis/parkito2/types.gen.ts";
  import { ListNavigationItem } from "./mod.ts";
  const { debtor }: { debtor: Debtor; onClick?: () => void } = $props();
  const cityAndZip = [debtor.city, debtor.zip].filter((i) => i).join(" ");
</script>
<ListNavigationItem
  title={debtor.name +
    (debtor.contactEmail ? " (" + debtor.contactEmail + ")" : "")}
  description={[debtor.address, cityAndZip].filter((i) => i).join(", ")}
  labelRight={"person" in debtor.sid ? "Privat" : "Företag"}
  isSingleItem
>
</ListNavigationItem>

<style lang="postcss" scoped>
</style>
